import { render, staticRenderFns } from "./GiftCardAmount.vue?vue&type=template&id=3c10f096&"
import script from "./GiftCardAmount.vue?vue&type=script&lang=js&"
export * from "./GiftCardAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports